import { render, staticRenderFns } from "./LabelView.vue?vue&type=template&id=3ebd890b&scoped=true&"
import script from "./LabelView.vue?vue&type=script&lang=js&"
export * from "./LabelView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ebd890b",
  null
  
)

export default component.exports